import screenfull from 'screenfull'
import detailsIcon from 'src/assets/DetailsIcon.png'
import forwardIcon from 'src/assets/ForwardIcon.png'
import pauseIcon from 'src/assets/PauseIcon.png'
import playIcon from 'src/assets/PlayIcon.png'
import rewindIcon from 'src/assets/RewindIcon.png'
import { LOOPED_PLAYER } from 'src/consumer/constants'
import {
  FullScreenButton,
  PrettoSlider,
  StyledControlBar,
  StyledDetailsIcon,
  StyledPlayBar,
  StyledPlayControls,
  StyledPlayPauseButton,
  StyledSliderContainer,
  StyledSpeedText,
} from './PlayerControlsStyle'
import fullScreenExitIcon from 'src/assets/full_screen_exit.png'
import fullScreenIcon from 'src/assets/full_screen_button.png'

export default function PlayerControls(props) {
  const format = (seconds) => {
    if (isNaN(seconds)) return '00:00'
    const date = new Date(seconds * 1000)
    const hh = date.getUTCHours()
    const mm = date.getUTCMinutes()
    const ss = date.getUTCSeconds().toString().padStart(2, '0')
    if (hh) return `${hh}:${mm.toString().padStart(2, '0')}:${ss}`
    return `${mm}:${ss}`
  }

  const {
    handleFastForward,
    handlePlayPause,
    handleRewind,
    handleSeek,
    currentTime,
    duration,
    play,
    handleSeekCommitted,
    setIsCourseDetailOpen,
    stepsArray,
    currentStep,
    playerType,
    playerRef,
    playbackRate,
    setPlaybackRate,
    handleClickFullScreen,
    handleExitFullScreen,
  } = props

  const marks = stepsArray.map((step, index) => {
    return {
      value: step.mark,
    }
  })
  marks.push({
    value: 100,
  })
  marks[currentStep] = {
    ...marks[currentStep],
    label: format(currentTime),
  }
  marks[currentStep + 1] = {
    ...marks[currentStep + 1],
    label: format(duration),
  }

  const handleFullScreenButtonClick = () => {
    if (!screenfull.isFullscreen) {
      handleClickFullScreen()
    } else {
      handleExitFullScreen()
    }
  }

  return (
    <StyledControlBar>
      <StyledPlayBar>
        <StyledDetailsIcon onClick={() => setIsCourseDetailOpen(true)}>
          <img src={detailsIcon} />
        </StyledDetailsIcon>

        <StyledPlayControls>
          <StyledPlayPauseButton small onClick={handleRewind} src={rewindIcon} />
          {play.playing && <StyledPlayPauseButton onClick={handlePlayPause} src={pauseIcon} />}
          {!play.playing && <StyledPlayPauseButton onClick={handlePlayPause} src={playIcon} />}
          <StyledPlayPauseButton small onClick={handleFastForward} src={forwardIcon} />
        </StyledPlayControls>

        <StyledSpeedText
          onClick={() => {
            if (playbackRate === 1) {
              setPlaybackRate(0.75)
            } else if (playbackRate === 0.75) {
              setPlaybackRate(0.5)
            } else if (playbackRate === 0.5) {
              setPlaybackRate(1.25)
            } else if (playbackRate === 1.25) {
              setPlaybackRate(1.5)
            } else if (playbackRate === 1.5) {
              setPlaybackRate(1)
            }
          }}
        >
          {playbackRate}
          {' x'}
        </StyledSpeedText>

        {screenfull.isEnabled && (
          <FullScreenButton
            src={!screenfull.isFullscreen ? fullScreenIcon : fullScreenExitIcon}
            onClick={handleFullScreenButtonClick}
          />
        )}
      </StyledPlayBar>

      {playerType !== LOOPED_PLAYER && (
        <StyledSliderContainer>
          <PrettoSlider
            value={(currentStep + play.played) * parseFloat(100 / stepsArray.length)}
            onChangeCommitted={handleSeekCommitted}
            marks={marks}
            onChange={handleSeek}
          />
        </StyledSliderContainer>
      )}
    </StyledControlBar>
  )
}
